var Authorization = (function ($, _, api, confirmPassword) {

    var providerType = {
        VisaCheckout: 1,
        BrainTree: 2,
        VisaCheckoutNative: 3
    }

    var isPending = false;

	var queryParams = _.reduce(window.location.search.substring(1).split('&'),
		function(memo, item) {
			var pair = item.split('=');
			memo[(pair[0] || '').toLowerCase()] = pair[1];
			return memo;
		}, {});

    function parceData(data) {
        var invitedBy = window.cookie && cookie.get('invitedBy') || null;
        data.invitedBy = invitedBy || queryParams['invitedby'] || null;
		data.referredBy = queryParams['referredby'] || null;
		data.voucherID = queryParams['voucherid'] || '00000000-0000-0000-0000-000000000000';
		data.password = null;
		return data;
    }

    function _unauthorized() {
        api.errorEmitter.trigger('unauthorized');
        return new $.Deferred().reject().promise();
    }

    function _confirmPassword(apiMethod, postdata, email, accountExists) {
        var $def = new $.Deferred();
        confirmPassword(email, accountExists, function (password, destroyPopup) {
            postdata.password = password;
            if (!isPending) {
                isPending = true;
                apiMethod(postdata)
                    .done(function (data) {
                        var isAuthenticated = data.Value && data.Value.IsAuthenticated || false;
                        if (data.Result && isAuthenticated) {
                            destroyPopup();
                            $def.resolve(data);
                        }
                    }).always(function () {
                        isPending = false;
                    });
            }
        });
        return $def.promise();
    }

    function _authorize(data, apiMethod) {
        var postdata = parceData(data);
        return apiMethod(postdata)
            .then(function (result) {
                var data = result.Value && result.Value.Data && result.Value.Data || {};
                if (result.Result && data.PasswordRequired) {
                    return _confirmPassword(apiMethod, postdata, data.Email, data.AccountExists);
                } else if (result.IsAuthenticated == false) {
                    return _unauthorized();
                }
                return result;
            });
    }

    var Authorization = function (options) {
        this.successCallback = options.successCallback;
        this.fid = options.fid;
        this.facebook = new FacebookAuthorization({
            appId: options.fid,
            authCallback: _.bind(this._fbAuthCallback, this),
            btnID: "@btnFb"
        });

        this.loginVisaType = options.providerType;

        if (options.providerType === providerType.VisaCheckout || options.providerType === providerType.VisaCheckoutNative) {
            /* Visa Checkout via ciber-source */
            this.visa = new VisaCheckoutAuthorization({
                enabled: options.visaEnabled,
                apikey: options.visaApiKey,
                visaApiDomain: options.visaApiDomain,
                authCallback: _.bind(this._visaAuthCallback, this)
            });
        } else if (options.providerType === providerType.BrainTree) {
            /* Visa Checkout via braintree */
            this.visa_braintree = VisaCheckoutBTAuthorization.init({
                enabled: options.visaEnabled,
                visaApiDomain: options.visaApiDomain,
                authCallback: _.bind(this._visaBtAuthCallback, this)
            });
        }
	};

    Authorization.prototype = {
        _fbAuthCallback: function (data) {
            _authorize(data, _.bind(api.loginFacebook, api))
                .done(_.bind(this.successCallback, this));
        },
        _visaAuthCallback: function (data) {
            _authorize({
                data: {
                    callID: data.callid,
                    encKey: data.encKey,
                    encPaymentData: data.encPaymentData,
                    loginVisaType: this.loginVisaType
                }
            }, _.bind(api.loginVisa, api))
                .done(_.bind(this.successCallback, this));
        },
        _visaBtAuthCallback: function (data) {
            _authorize({
                data: {
                    firstName: data.userData.userFirstName,
                    lastName: data.userData.userLastName,
                    email: data.userData.userEmail,
                    callID: data.callId,
                    paymentNonce: data.nonce,
                    loginVisaType: this.loginVisaType
                }
            }, _.bind(api.loginVisa, api))
                .done(_.bind(this.successCallback, this));
        }
	};

	return Authorization;

})(jQuery, _, api, confirmPassword);